import { Pipe, PipeTransform } from '@angular/core';
import { OrganisationsTyp } from 'src/app/domain/model/organisationsTyp';

@Pipe({
    name: 'orgTypeReadable',
    standalone: false,
})
export class OrgTypeReadablePipe implements PipeTransform {

    transform(orgaType: OrganisationsTyp): string {
        switch (orgaType) {
            case OrganisationsTyp.VNB:
                return 'VNB';
            case OrganisationsTyp.UENB:
                return 'ÜNB';
            case OrganisationsTyp.NVNB_NICHTINTEGRIERT:
                return 'nVNB nicht integriert';
            case OrganisationsTyp.NVNB_TEILINTEGRIERT:
                return 'nVNB teilintegriert';
            case OrganisationsTyp.NVNB_VOLLINTEGRIERT:
                return 'nVNB vollintegriert';
            default:
                return '';
        }
    }

}
